import { render, staticRenderFns } from "./latestnews.vue?vue&type=template&id=103c3ad1&scoped=true"
import script from "./latestnews.vue?vue&type=script&lang=js"
export * from "./latestnews.vue?vue&type=script&lang=js"
import style0 from "./latestnews.vue?vue&type=style&index=0&id=103c3ad1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103c3ad1",
  null
  
)

export default component.exports